<div class="mb-3">
  <div *ngIf="inputContent.inputContentDatas as inputContentDatas">
    <app-field-title
      [titleInfo]="inputContent"
      [formControlObj]="formControlObj"
    >
      <div class="d-flex flex-wrap">
        <div
          class="m-1"
          *ngFor="let data of inputContentDatas"
          [class.w-100]="data.extraValueType === InputContentDataExtraValueType.Textarea"
        >
          <input
            type="checkbox"
            class="form-check-input me-1"
            [id]="'check-' + data.key"
            [value]="data.key"
            (change)="selectOption($event, data)"
            [checked]="data.checked"
          />
          <label
            class="form-check-label font-weight-normal"
            [for]="'check-' + data.key"
          >
            {{ data.value }}
          </label>
          <input
            class="bottom-border-input form-control"
            [(ngModel)]="data.extraValue"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onExtraOptionValueChange(data)"
            [disabled]="!data.checked"
            *ngIf="
              data.extraValueType === InputContentDataExtraValueType.Textbox
            "
            type="text"
          />
          <textarea
            class="form-control mt-1"
            style="white-space: pre-line"
            rows="3"
            [(ngModel)]="data.extraValue"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onExtraOptionValueChange(data)"
            *ngIf="
              data.extraValueType === InputContentDataExtraValueType.Textarea &&
              data.checked
            "
          ></textarea>
        </div>
      </div>
    </app-field-title>
  </div>
</div>
